module.exports = __webpack_public_path__ + "static/img/i2.f06c5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i2.png
// module id = PPLp
// module chunks = 0